import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @summary Удаление домена
 */
export const InitDeleteDomainContentType = '' as const;
export type InitDeleteDomainRequest = void;
export type InitDeleteDomainResponses = LinkCommonErrorResponses & {
    /**
     * @description Процесс удаления домена запущен
     */
    '200': {
        'application/json': unknown;
    };
};
export type InitDeleteDomainResponseSuccess = InitDeleteDomainResponses['200']['application/json'];
export type InitDeleteDomainSearchParams = undefined;
export type InitDeleteDomainPathParameters = undefined;
export const InitDeleteDomainUrl = '/awacs/domain' as const;
export const InitDeleteDomainMethod = 'DELETE' as const;
export const getInitDeleteDomainUrl = (_params?: InitDeleteDomainPathParameters) => InitDeleteDomainUrl;
